export default {"src":"/_next/static/media/golden-star.4709b7a0.svg","height":11,"width":10,"blurWidth":0,"blurHeight":0};